import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FiBriefcase, FiChevronDown, FiCoffee, FiLink2, FiPackage, FiShoppingBag, FiGrid } from "react-icons/fi";
import "./Sidebar.css";
import { useAccess } from "../../hooks/useAccess";
import LogoutButton from "../LogoutButton/LogoutButton";
import logo from "../../assets/images/navo-logo.png";
import dashboardIcon from "../../assets/images/dashboardicon.png";
import customersIcon from "../../assets/images/customers.png";
import shipmentIcon from "../../assets/images/shipment-icon.png";
import quoteIcon from "../../assets/images/quote-icon.png";
import trackingIcon from "../../assets/images/trackingicon.png";
import fxIcon from "../../assets/images/fximage.png";
import transactionIcon from "../../assets/images/transactionicon.png";
import supportTicketIcon from "../../assets/images/support.png";
import auditIcon from "../../assets/images/usermagg.png";
import usersIcon from "../../assets/images/usermgt.png";
import settingsIcon from "../../assets/images/settings.png";
import logoutIcon from "../../assets/images/logoutIcon.png";

const SHOP_LINKS = [
  { path: "/purchase-orders", label: "Fooding", Icon: FiCoffee },
  { path: "/shop-with-link", label: "Shop With Link", Icon: FiLink2 },
  { path: "/naija-shop", label: "Naija Shop", Icon: FiShoppingBag },
  { path: "/amazon", label: "Amazon", Icon: FiPackage },
];
const MAIN_LINKS = [
  { path: "/dashboard", label: "Dashboard", icon: dashboardIcon },
  { path: "/customers", label: "Customers", icon: customersIcon },
  { path: "/shipments", label: "Shipments", icon: shipmentIcon },
  { path: "/quote-request", label: "Quote Request", icon: quoteIcon },
  { path: "/tracking", label: "Tracking Mgt.", icon: trackingIcon },
];
const OTHER_LINKS = [
  { path: "/fx", label: "FX", icon: fxIcon },
  { path: "/transactions", label: "Transaction", icon: transactionIcon },
  { path: "/support", label: "Support Ticket", icon: supportTicketIcon },
];
const ACCOUNT_LINKS = [
  { path: "/audit", label: "Audit Mgt.", icon: auditIcon },
  { path: "/user-management", label: "User Mgt.", icon: usersIcon },
  { path: "/settings", label: "Settings", icon: settingsIcon },
];
export default function Sidebar({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  const location = useLocation();
  const access = useAccess();
  const shopLinks = SHOP_LINKS.filter(item => access.canVisit(item.path));
  const shopActive = shopLinks.some(item => location.pathname.startsWith(item.path));
  const [shopsOpen, setShopsOpen] = useState(shopActive);
  useEffect(() => { if (shopActive) setShopsOpen(true); }, [shopActive]);
  const active = (path: string) => location.pathname.startsWith(path) ? "active" : "";
  const links = (items: typeof MAIN_LINKS) => items.filter(item => access.canVisit(item.path)).map(item =>
    <li key={item.path} className={active(item.path)}><Link to={item.path} onClick={onClose}><img src={item.icon} alt="" />{item.label}</Link></li>);
  return <aside className={`sidebar ${isOpen ? "open" : ""}`}>
    <div className="sidebar-logo"><Link to="/" onClick={onClose}><img src={logo} alt="Navo+ Logo" /></Link></div>
    <nav className="sidebar-nav"><ul>{links(MAIN_LINKS)}
      {shopLinks.length > 0 && <li className={`sidebar-group${shopActive ? " active-group" : ""}`}>
        <button type="button" className={`sidebar-group-toggle${shopsOpen ? " open" : ""}`} onClick={() => setShopsOpen(value => !value)} aria-expanded={shopsOpen}><FiGrid className="nav-icon-svg" /><span>Shops &amp; Orders</span><FiChevronDown className="sidebar-group-chevron" /></button>
        {shopsOpen && <ul className="sidebar-subnav">{shopLinks.map(({ path, label, Icon }) => <li key={path} className={active(path)}><Link to={path} onClick={onClose}><Icon className="nav-icon-svg" />{label}</Link></li>)}</ul>}
      </li>}
      {access.canVisit("/vendors") && <li className={active("/vendors")}><Link to="/vendors" onClick={onClose}><FiBriefcase className="nav-icon-svg" />Vendors</Link></li>}
      {links(OTHER_LINKS)}
    </ul><hr className="sidebar-divider" /><ul>{links(ACCOUNT_LINKS)}</ul></nav>
    <div className="sidebar-logout"><LogoutButton><img src={logoutIcon} alt="" />Logout</LogoutButton></div>
  </aside>;
}
